var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZonesImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 200,
    viewBox: "0 0 168 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6455 92.2147H17.5508V121.309H46.6455V92.2147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6455 52.1465H17.5508V81.2412H46.6455V52.1465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6455 12.0782H17.5508V41.1729H46.6455V12.0782Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.8988 80.9934C96.9631 81.2228 97.064 81.5531 97.2383 81.911C97.4769 82.3973 97.8623 82.9753 98.7431 83.7185C99.8349 84.6452 100.101 84.48 101.395 85.4801C102.055 85.9848 102.633 86.5261 102.909 86.783C104.111 87.9024 104.468 88.4621 104.982 88.3795C105.358 88.3153 105.689 87.9299 105.735 87.5721C105.762 87.3702 105.707 87.1042 104.753 86.0765C103.955 85.2232 103.679 85.0764 103.468 84.581C103.276 84.113 103.276 83.6634 103.303 83.379C103.725 83.3423 104.349 83.324 105.074 83.5075C105.982 83.7277 106.625 84.1405 106.992 84.425C107.735 85.3609 108.487 86.2876 109.23 87.2234C109.662 87.7556 110.341 87.8382 110.717 87.5537C111.065 87.2877 111.029 86.7739 111.029 86.7096L108.79 83.6818C109.588 84.113 110.148 84.5718 110.515 84.9204C111.717 86.0582 112.304 87.3611 113.056 87.3244C113.469 87.306 113.69 87.0675 113.69 87.0675C113.726 87.0216 113.864 86.8748 113.864 86.6729C113.864 86.5353 113.79 86.4435 113.552 86.0949C113.68 86.0398 113.91 85.9297 114.02 85.6912C114.148 85.3976 114.02 85.0856 113.928 84.8837C113.836 84.6727 111.322 81.6816 111.717 82.0578L107.138 80.4521C107.138 80.4521 104.468 79.0116 103.395 78.5987C102.331 78.1858 99.5322 77.1857 99.5322 77.1857L95.7244 75.7911C94.8528 77.2408 93.9811 78.6996 93.1187 80.1493C94.3757 80.4338 95.6327 80.7182 96.8988 81.0026V80.9934Z",
    fill: "#FFC0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.551 83.0762C111.836 83.2872 111.964 83.4982 112.185 83.8102C112.377 84.0763 112.249 83.8652 112.919 84.7094C113.166 85.0213 113.487 85.4342 113.845 85.9113C113.744 85.9939 113.634 86.049 113.561 86.0857C112.818 85.1498 112.074 84.2139 111.331 83.278C111.184 83.1955 111.038 83.1129 110.882 83.0395C110.221 82.7 109.588 82.4523 108.982 82.2596C109.395 82.3422 110.285 82.5165 111.029 82.8009C111.184 82.8651 111.368 82.9386 111.561 83.0762H111.551Z",
    fill: "#F29EA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8988 80.9935L96.541 80.9109C96.6786 80.7641 96.9264 80.5255 97.3117 80.3604C97.7522 80.1677 98.1467 80.1585 98.3485 80.1677C97.5962 80.4062 97.1649 81.1219 96.9998 81.4522C96.9447 81.2871 96.9172 81.1219 96.8988 80.9843V80.9935Z",
    fill: "#F29EA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.524 83.6818C110.056 84.0855 110.854 84.7002 111.598 85.6453C111.8 85.9022 111.91 86.0673 112.203 86.4068C112.561 86.8197 112.891 87.1225 113.102 87.306H113.066C112.313 87.3427 111.717 86.0398 110.524 84.9021C110.157 84.5534 109.597 84.0947 108.799 83.6634C108.799 83.6634 108.111 82.9477 107.928 82.8652C107.744 82.7826 105.716 81.8742 105.716 81.8742C107.01 82.1678 107.946 82.6358 108.542 83.0028C108.964 83.2597 109.276 83.4983 109.524 83.6818Z",
    fill: "#F29EA4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1436 35.0714C67.8043 36.255 69.5384 37.7322 71.1991 39.5947C78.3191 47.6047 79.1999 57.358 79.3009 61.6153C86.008 66.3406 92.7059 71.075 99.413 75.8003C98.0734 78.3602 96.7338 80.9201 95.4034 83.4891C86.6502 82.7276 77.897 81.9569 69.1439 81.1953C68.1438 65.8176 67.1528 50.4491 66.1527 35.0714H66.1436Z",
    fill: "url(#paint0_linear_189_1578)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15502 56.5689C3.15502 56.5689 2.40264 55.8165 6.91687 54.0641C8.43996 53.4677 12.8716 52.7337 18.34 52.1097C16.8078 66.9278 15.7251 79.6905 14.936 89.9301C14.1011 100.839 13.9359 104.739 15.9361 109.492C21.111 121.777 35.1032 126.31 49.7928 131.063C62.9593 135.32 84.3559 141.293 109.478 133.824C128.039 128.31 129.287 123.539 129.287 123.539C131.04 124.291 131.544 126.549 131.792 131.31C132.04 136.072 132.04 172.691 132.04 172.691C132.04 172.691 131.287 185.233 119.002 192.005C106.716 198.776 40.2505 210.566 6.89851 179.967C3.47615 160.754 0.815329 138.137 0.374918 112.758C0.017083 92.0129 1.21904 73.1486 3.13667 56.5781L3.15502 56.5689Z",
    fill: "url(#paint1_linear_189_1578)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.487 133.806C84.3656 141.275 62.969 135.311 49.8025 131.044C35.1129 126.292 21.1206 121.768 15.9458 109.473C13.9456 104.721 14.1108 100.821 14.9457 89.9118C15.7256 79.6723 16.8175 66.9003 18.3497 52.0915C29.0664 50.862 43.8294 50.0454 48.8024 51.5409C48.8024 51.5409 50.3071 52.0456 51.0595 54.5504C51.8119 57.0553 68.364 94.4261 80.9066 101.95C93.4491 109.473 127.554 122.768 129.306 123.521C129.306 123.521 128.049 128.283 109.497 133.806H109.487Z",
    fill: "url(#paint2_linear_189_1578)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9282 51.3573C35.131 50.6141 44.921 50.3848 48.7929 51.5408C48.7929 51.5408 50.2977 52.0455 51.05 54.5503C51.8024 57.0552 68.3546 94.4259 80.8971 101.95C90.2192 107.547 111.46 116.318 122.461 120.768C90.054 119.364 80.1447 132.797 80.1447 132.797C74.3735 128.283 53.8118 125.025 53.8118 125.025C53.8118 125.025 45.7835 115.749 43.7833 100.445C42.04 87.15 34.9934 62.1291 25.9282 51.3573Z",
    fill: "#624B66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.204 188.793L119.085 171.553L109.524 170.984C110.304 177.122 111.093 183.261 111.873 189.39C113.644 189.188 115.424 188.986 117.195 188.793H117.204Z",
    fill: "#FFC0C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.562 194.849C126.398 194.821 128.49 194.803 131.38 194.464C131.196 194.17 130.958 194.014 130.875 193.959C127.122 191.867 124.205 190.252 122.351 189.179L119.516 187.83C118.131 187.16 117.424 186.793 116.699 187.059C116.185 187.252 116.25 187.546 115.507 187.94C115.158 188.124 114.341 188.555 113.405 188.316C112.589 188.105 112.121 187.5 111.947 187.252C111.947 187.252 108.827 189.032 110.231 193.849C110.974 193.987 112.029 194.17 113.304 194.344C117.424 194.895 120.599 194.877 123.562 194.849Z",
    fill: "url(#paint3_linear_189_1578)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.38 194.473C128.489 194.812 126.398 194.831 123.562 194.858C120.599 194.886 117.424 194.904 113.304 194.354C112.029 194.179 110.974 193.996 110.231 193.858C110.231 193.858 108.919 195.427 111.029 196.638L131.471 196.069C131.526 195.959 131.756 195.464 131.563 194.858C131.517 194.711 131.453 194.592 131.38 194.482V194.473Z",
    fill: "#312B30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.465 186.188C152.391 180.508 151.327 174.829 150.253 169.14L140.94 171.379C143.473 177.022 146.005 182.664 148.547 188.307C150.189 187.601 151.831 186.894 153.465 186.188Z",
    fill: "#FFC0C2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.612 192.794C162.447 192.766 164.539 192.748 167.429 192.408C167.245 192.115 167.007 191.959 166.924 191.904C163.162 189.821 160.254 188.197 158.391 187.124L155.556 185.775C154.171 185.105 153.464 184.738 152.739 185.004C152.226 185.197 152.29 185.49 151.547 185.885C151.198 186.068 150.381 186.5 149.445 186.261C148.629 186.05 148.161 185.444 147.987 185.197C147.987 185.197 144.867 186.977 146.271 191.794C147.014 191.931 148.069 192.115 149.345 192.289C153.464 192.84 156.639 192.821 159.602 192.794H159.612Z",
    fill: "url(#paint4_linear_189_1578)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167.429 192.408C164.539 192.748 162.447 192.766 159.612 192.794C156.648 192.821 153.473 192.84 149.354 192.289C148.078 192.115 147.023 191.931 146.28 191.794C146.28 191.794 144.968 193.363 147.078 194.574L167.521 194.005C167.576 193.895 167.805 193.399 167.612 192.794C167.567 192.647 167.502 192.528 167.429 192.418V192.408Z",
    fill: "#312B30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.446 184.031C136.766 165.47 129.096 146.899 121.416 128.338C114.975 130.264 104.653 132.531 92.0095 131.677C79.9165 130.861 64.3736 129.76 55.4553 117.979C48.3628 108.62 49.0877 96.9033 49.9685 91.0403C56.4004 88.3794 62.823 85.7186 69.2549 83.0578C74.4389 85.8012 79.6229 88.5446 84.8069 91.288C89.4863 92.4533 96.0007 94.1048 103.772 96.1784C128.94 102.913 135.427 105.574 140.17 111.474C143.73 115.896 144.868 120.337 146.162 126.255C148.896 138.752 152.208 157.221 154.089 181.508C150.878 182.352 147.667 183.187 144.455 184.031H144.446Z",
    fill: "url(#paint5_linear_189_1578)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.882 185.793C107.625 169.149 105.358 152.514 103.101 135.871C92.0818 134.65 82.6772 133.549 75.3921 132.678C50.4537 129.686 44.5357 128.806 40.049 123.86C37.8286 121.41 32.4794 114.134 35.6541 97.1235C46.3249 93.747 57.0049 90.3797 67.6757 87.0032C70.5292 90.2696 73.3827 93.5268 76.2362 96.7932C81.6771 97.5089 89.6229 98.6649 99.1743 100.463C120.534 104.491 125.25 106.611 128.232 110.556C132.297 115.942 131.774 122.658 130.985 129.521C129.48 142.559 126.333 161.791 119.057 186.105C116.002 186.004 112.937 185.903 109.882 185.802V185.793Z",
    fill: "url(#paint6_linear_189_1578)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4065 74.0844C35.3606 79.2134 35.2597 87.4619 34.9478 97.9401C41.0401 98.1878 49.7658 97.83 59.7209 94.9581C67.0519 92.8478 72.9792 89.9576 77.3833 87.3885C77.5209 82.3697 77.5117 78.094 77.4567 74.7818C77.3924 70.1666 77.2365 66.1203 76.8052 60.6886C76.6676 58.8811 76.4382 56.8441 76.0529 54.3852C75.0895 48.1827 73.86 43.852 70.7496 39.7965C69.0246 37.5394 67.1896 35.9888 65.8775 35.0162C63.7305 34.6767 61.4642 34.2455 59.0878 33.7042C56.6564 33.1537 54.3717 32.5389 52.2431 31.9058C49.8484 32.227 46.426 33.0803 43.6367 35.6493C43.6367 35.6493 43.0495 36.1998 42.5357 36.8513C35.6359 45.4118 35.3973 74.0936 35.3973 74.0936L35.4065 74.0844Z",
    fill: "url(#paint7_linear_189_1578)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6195 21.9415C56.2986 21.9232 59.1704 22.1251 62.3451 23.5564C64.5746 24.5657 66.1895 25.841 67.2446 26.8228C66.8776 29.5754 66.5015 32.3188 66.1344 35.0713C64.6205 35.4934 61.4918 36.1448 57.7207 35.2457C54.803 34.5483 52.7202 33.2179 51.5366 32.3279C52.5642 28.8597 53.5919 25.4006 54.6195 21.9324V21.9415Z",
    fill: "#FFC0C2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1967 27.7495C53.3162 28.0981 55.8761 28.1348 58.5553 27.2815C68.6664 24.0335 70.9602 10.9679 71.0519 10.4266C73.043 10.8028 75.034 11.179 77.0159 11.5551C78.2453 11.7845 79.0161 11.5551 79.7501 11.1423C80.8511 10.5275 81.7686 9.21546 81.7778 8.18783C81.8053 4.39845 69.4921 1.6734 66.4001 0.994437C57.2707 -1.02412 54.9953 0.526499 54.1511 1.31557C52.6556 2.70103 52.2886 4.57278 52.0684 5.87567C50.7838 13.6012 50.8939 21.9691 51.2059 27.7586L51.1967 27.7495Z",
    fill: "url(#paint8_linear_189_1578)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9688 28.8964C66.6385 28.7496 66.2807 28.6395 65.9045 28.6028C65.7944 28.2541 65.6935 27.9054 65.5834 27.5568C64.9594 26.9604 63.3263 25.5657 60.8856 25.3088C59.9222 25.2079 59.0965 25.3088 58.4634 25.4373C58.4634 26.4466 58.6194 28.2082 59.6929 29.9423C61.4086 32.6949 64.3539 33.6216 66.2899 33.9336C66.5192 32.2545 66.7394 30.5754 66.9688 28.9055V28.8964Z",
    fill: "#F29EA4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5004 21.7672C58.3535 21.7397 57.7938 21.2717 57.5828 21.0699C56.0046 19.5468 57.2249 15.9593 58.5829 15.4271C59.2985 15.1427 59.8949 15.3537 59.8949 15.3537C59.9775 15.3812 60.2161 15.473 60.4638 15.7024C61.4822 16.6291 61.418 18.6109 61.418 18.6109C61.73 18.4366 62.0419 18.2714 62.3539 18.0971C62.152 13.537 65.0973 9.79351 68.7215 9.18795C72.4742 8.56403 75.346 11.5643 75.5938 11.8212C75.7681 13.0966 75.9149 14.4454 76.0158 15.8584C76.1626 17.8127 76.2085 19.6569 76.181 21.3635C76.4012 21.6296 76.6581 22.0333 76.5664 22.4462C76.4838 22.8224 76.1535 22.9416 75.8323 23.3637C75.447 23.8592 75.3827 24.3638 75.3002 24.7859C74.9607 26.5108 73.9606 29.245 73.3825 30.5571C72.6118 32.3004 72.2265 33.172 71.5383 33.6125C68.4738 35.6035 62.776 30.759 60.5739 28.8964C59.5921 28.0614 58.2617 26.7769 58.4085 25.4006C58.4361 25.1437 58.5737 24.6849 58.849 23.7766C59.1059 22.9233 59.3444 22.226 59.5096 21.7489L59.5004 21.7672Z",
    fill: "#FFC0C2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3089 27.2265C69.9052 29.1533 71.0704 31.0342 72.933 31.5756C73.0706 31.2728 73.2174 30.9517 73.3826 30.5755C73.6487 29.9699 74.0065 29.0524 74.346 28.0798L70.3089 27.2265Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M116.983 103.803C118.295 103.922 119.552 103.161 120.03 101.904L134.224 64.4779C134.802 62.9456 134.031 61.239 132.508 60.661C130.976 60.083 129.269 60.8537 128.691 62.3768L115.369 97.5088L77.6216 90.7375C76.0159 90.453 74.4744 91.5174 74.19 93.1322C73.9056 94.7379 74.9699 96.2793 76.5848 96.5637L116.754 103.766C116.837 103.785 116.919 103.794 117.002 103.803H116.983Z",
    fill: "url(#paint9_linear_189_1578)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1639 83.5534C82.4116 83.0212 82.8795 82.2229 83.7604 81.7642C84.2008 81.5348 84.5127 81.5073 86.8524 81.544C86.8524 81.544 88.1278 81.5623 90.7978 81.9293C91.2107 81.9844 91.8438 82.0853 92.0823 82.5349C92.2108 82.7918 92.1832 83.1129 92.0823 83.3515C91.908 83.7369 91.4951 83.9846 91.018 84.0121C89.9261 84.0121 88.8251 84.0121 87.7333 84.0121C90.706 84.7828 93.6788 85.5536 96.6516 86.3243C97.1929 86.4527 97.5232 86.9941 97.3948 87.4987C97.2847 87.9575 96.8259 88.2786 96.3213 88.2236C94.633 87.9391 92.9448 87.6547 91.2565 87.3611C92.8714 87.9116 94.4862 88.4713 96.1011 89.0218C96.6332 89.1411 96.9819 89.6365 96.9268 90.1137C96.8626 90.6642 96.2846 91.0954 95.6698 90.967C94.0275 90.5724 92.3759 90.1779 90.7335 89.7833C92.2566 90.3797 93.7889 90.967 95.312 91.5542C95.7708 91.7927 96.0001 92.3065 95.8809 92.7286C95.7341 93.2608 95.0826 93.6186 94.4495 93.38C92.8989 92.9305 91.3483 92.4809 89.7977 92.0313C91.2107 92.5543 92.6145 93.0773 94.0275 93.6002C94.3211 93.8847 94.4037 94.3251 94.2385 94.7013C94.0825 95.0591 93.7155 95.2977 93.3118 95.2885C88.1094 93.7195 84.265 92.4625 82.9162 91.9579C82.5859 91.8386 81.9253 91.5817 81.3106 90.967C80.705 90.3614 80.4389 89.7099 80.3288 89.3613C79.604 89.2053 78.7874 89.031 77.9341 88.8383L79.8792 82.5533C80.6408 82.8836 81.4115 83.2139 82.173 83.5442L82.1639 83.5534Z",
    fill: "#FFC0C2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7285 32.0527C50.3339 31.9334 48.3887 31.8875 46.1041 32.2362C46.1041 32.2362 45.5169 32.3279 44.6728 32.5114C44.6728 32.5114 43.1589 32.8418 41.7459 33.3372C40.7274 33.6951 35.0938 37.2826 32.5064 48.4764C31.1943 54.1559 27.8729 68.4876 36.1765 77.5344C39.6814 81.3513 44.7829 82.7826 54.8298 85.4893C64.5372 88.0951 72.8316 89.2328 78.6854 89.7742C79.346 87.3244 80.0067 84.8838 80.6764 82.434C71.3452 76.415 62.0232 70.4052 52.6919 64.3863C52.3708 53.6145 52.0497 42.8336 51.7285 32.0619V32.0527Z",
    fill: "url(#paint10_linear_189_1578)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_189_1578",
    x1: 99.6149,
    y1: 78.5987,
    x2: 76.6767,
    y2: 63.9183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7AA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46B45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_189_1578",
    x1: -6.53404,
    y1: 71.1576,
    x2: 117.075,
    y2: 204.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C06C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A26581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#8C607F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7E5D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5D7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_189_1578",
    x1: 117.176,
    y1: 141.945,
    x2: 14.175,
    y2: 70.0933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C06C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A26581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#8C607F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7E5D7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5D7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_189_1578",
    x1: 130.924,
    y1: 195.901,
    x2: 110.288,
    y2: 189.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7AA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46B45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_189_1578",
    x1: 167.011,
    y1: 193.929,
    x2: 146.375,
    y2: 187.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7AA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46B45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_189_1578",
    x1: 64.8551,
    y1: 95.3368,
    x2: 176.501,
    y2: 170.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AEDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#63DBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#6ACDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC9C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_189_1578",
    x1: 131.182,
    y1: 174.714,
    x2: 62.6816,
    y2: 90.9385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AEDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#63DBC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#6ACDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC9C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_189_1578",
    x1: 73.6571,
    y1: 44.5787,
    x2: 33.4419,
    y2: 96.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7AA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46B45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_189_1578",
    x1: 50.5514,
    y1: 12.6256,
    x2: 79.5204,
    y2: 18.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#082235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E3150"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_189_1578",
    x1: 130.833,
    y1: 83.3341,
    x2: 77.6727,
    y2: 73.7116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_189_1578",
    x1: 70.7059,
    y1: 89.7977,
    x2: 31.3132,
    y2: 38.3575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F7AA46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46B45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonesImage);
export default __webpack_public_path__ + "static/media/zones-image.e6a32da6.svg";
export { ForwardRef as ReactComponent };